window.PlummeI18n.register('no', {
  'bank.archive.filter.postingType': 'Posteringstype',
  'bank.archive.filter.purchase': 'Kjøp',
  'bank.archive.filter.otherSale': 'Annet salg',
  'bank.archive.filter.payment': 'Betaling',
  'bank.archive.filter.manualPosting': 'Fri postering',
  'bank.archive.filter.bankPosting': 'Bankpostering',
  'bank.archive.filter.publicPayment': 'Lønn og avgifter',
  'bank.archive.filter.ignored': 'Ignorert banklinje',
  'bank.archive.filter.documentation': 'Dokumentasjon',
  'bank.archive.filter.missingAttachment': 'Mangler bilag',
  'bank.archive.filter.hasAttachment': 'Har bilag',
  'bank.archive.sort.label': 'Sorter posteringer',
  'bank.archive.sort.statementOrder': 'Rekkefølge i bankutskrift',
  'bank.archive.sort.dateDesc': 'Dato: nyeste først',
  'bank.archive.sort.dateAsc': 'Dato: eldste først',
  'bank.archive.sort.amountDesc': 'Beløp: høyest først',
  'bank.archive.sort.amountAsc': 'Beløp: lavest først',
});
